const checkRutubeLink = (link: string | undefined) => {
  if (!link) return false
  return link.includes('rutube.ru')
}

const extractIdAndKey = (url: string) => {
  const urlObj = new URL(url)

  const pathSegments = urlObj.pathname.split('/')
  const rutubeVideoId = pathSegments[pathSegments.length - 2]

  const rutubePrivatkey = urlObj.searchParams.get('p') || ''

  return { rutubeVideoId, rutubePrivatkey }
}

const checkJsonString = (str: string) => {
  try {
    JSON.parse(str)
  } catch (e) {
    return false
  }
  return true
}

export { checkRutubeLink, extractIdAndKey, checkJsonString }
